import {
  setCookie,
  getCookie,
  getQueryString,
} from "@/util/extends/cookieExpand";
//系统列表
const INITPORT = () => {
  let port = getQueryString("port");
  if (port) {
    sessionStorage.setItem("caxa-websocket-port", port);
    sessionStorage.setItem("caxa-port", port);
  }
};
const setToken = () => {
  let urlToken = getQueryString("Oauth2-AccessToken");
  if (urlToken !== "0000") {
    sessionStorage.setItem("Oauth2-AccessToken", urlToken);
  }
};

INITPORT();



// WEBPACK FOOTER //
// ./src/util/init.js